import { motion } from "framer-motion";

export default function Profile() {
  return (
    <section
      className="relative py-24 lg:py-32 border-t border-[#FAF9F6]/10"
      data-testid="profile-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-4"
        >
          <div className="overline mb-5">Il Fondatore</div>
          <h2 className="font-display text-3xl lg:text-5xl font-medium leading-[1.05] tracking-tight">
            Avv. Francesco
            <span className="block italic font-normal text-[#C5A880]">
              Ricciardi
            </span>
          </h2>
          <div className="mt-6 text-sm text-[#FAF9F6]/60 leading-relaxed">
            Fondatore dello Studio · Iscritto all&apos;Ordine degli Avvocati ·
            Head of Legal Affairs · Diritto commerciale, societario e
            immobiliare.
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-8 space-y-6 text-[15px] lg:text-base text-[#FAF9F6]/80 leading-relaxed"
        >
          <p>
            Lo Studio Legale Ricciardi offre assistenza e consulenza legale
            specialistica in diritto commerciale, societario ed immobiliare,
            con focus su contrattualistica d&apos;impresa, governance
            societaria, operazioni straordinarie (M&amp;A) e operazioni
            immobiliari.
          </p>
          <p>
            Come Head of Legal Affairs l&apos;Avv. Ricciardi gestisce
            questioni legali complesse connesse alla vita societaria ed alla
            governance, supportando il Management e gli altri Dipartimenti
            nelle decisioni strategiche di business. Lo Studio segue
            operazioni di M&amp;A che coinvolgono anche fondi di private
            equity e fornisce consulenza in ambito Real Estate, assistendo
            società e persone fisiche in appalti di opere edili,
            acquisizioni, dismissioni, riqualificazione e valorizzazione
            immobiliare.
          </p>

          <div className="pt-8 mt-8 border-t border-[#FAF9F6]/10">
            <div className="overline mb-2">Approccio</div>
            <p className="text-sm text-[#FAF9F6]/70 leading-relaxed max-w-xl">
              Integrato e orientato al risultato. Soluzioni su misura che
              combinano rigore tecnico e visione strategica.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
